[
  {
    "horizontal": [
      {
        "drawToPosition": 100,
        "drawFull": true,
        "drawFromPosition": 0,
        "startPosition": 5.6,
        "name": "PrimaryTop"
      },
      {
        "drawToPosition": 50,
        "name": "Equator",
        "startPosition": 50,
        "drawFull": true,
        "delay": 100,
        "drawFromPosition": 0
      },
      {
        "startPosition": 50,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "name": "EquatorRight",
        "delay": 100,
        "drawFull": true
      },
      {
        "drawToPosition": 100,
        "startPosition": 94.4,
        "drawFromPosition": 0,
        "delay": 200,
        "drawFull": true,
        "name": "PrimaryBottom"
      }
    ],
    "mask": [],
    "delayVertical": true,
    "vertical": [
      {
        "drawToPosition": 0,
        "drawFull": true,
        "name": "PrimaryLeft",
        "startPosition": 3.1,
        "drawFromPosition": 100
      },
      {
        "startPosition": 26,
        "name": "Left1",
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "drawFull": true
      },
      {
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "name": "Left1Bottom",
        "drawFull": true,
        "startPosition": 26
      },
      {
        "drawToPosition": 50,
        "name": "Equator",
        "drawFromPosition": 0,
        "drawFull": true,
        "startPosition": 50
      },
      {
        "name": "EquatorBottom",
        "drawToPosition": 100,
        "drawFull": true,
        "drawFromPosition": 50,
        "startPosition": 50
      },
      {
        "drawFromPosition": 0,
        "name": "Right1",
        "drawFull": true,
        "drawToPosition": 50,
        "startPosition": 74
      },
      {
        "drawFromPosition": 50,
        "drawFull": true,
        "name": "RightBottom",
        "drawToPosition": 100,
        "startPosition": 74
      },
      {
        "drawToPosition": 0,
        "drawFromPosition": 100,
        "drawFull": true,
        "name": "PrimaryRight",
        "startPosition": 96.9
      }
    ],
    "id": 0,
    "circle": [],
    "duration": "1000",
    "drawBorder": true,
    "delayHorizontal": true,
    "verticalDelayDirection": -1,
    "name": "ChapterSetup"
  },
  {
    "circle": [],
    "delayVertical": false,
    "name": "ChapterEntry",
    "delayHorizontal": false,
    "drawBorder": true,
    "horizontal": [
      {
        "startPosition": 5.6,
        "drawToPosition": 100,
        "drawFull": true,
        "drawFromPosition": 0,
        "name": "PrimaryTop"
      },
      {
        "drawFull": true,
        "name": "LeftTopAux",
        "startPosition": 50,
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "delay": 100,
        "endPosition": 27.5
      },
      {
        "name": "Equator",
        "drawToPosition": 50,
        "drawDirection": 1,
        "startPosition": 50,
        "endPosition": 50,
        "drawFromPosition": 0,
        "drawFull": true
      },
      {
        "startPosition": 72.2,
        "drawToPosition": 25,
        "name": "LeftAux",
        "drawFull": false,
        "drawFromPosition": 50,
        "drawDirection": 1
      },
      {
        "endPosition": 72.2,
        "delay": 100,
        "drawToPosition": 100,
        "startPosition": 50,
        "drawFull": true,
        "name": "EquatorRight",
        "drawFromPosition": 50
      },
      {
        "drawFull": true,
        "drawToPosition": 100,
        "name": "PrimaryBottom",
        "delay": 200,
        "drawFromPosition": 0,
        "startPosition": 94.4
      }
    ],
    "vertical": [
      {
        "name": "Left1",
        "drawFull": true,
        "drawToPosition": 50,
        "endPosition": -1,
        "drawFromPosition": 0,
        "startPosition": 26
      },
      {
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "endPosition": -1,
        "name": "PrimaryLeft",
        "startPosition": 3.1,
        "drawFull": true
      },
      {
        "endPosition": 25,
        "drawToPosition": 100,
        "startPosition": 26,
        "drawFromPosition": 50,
        "drawFull": true,
        "name": "Left1Bottom"
      },
      {
        "drawFull": false,
        "drawToPosition": 72.2,
        "startPosition": 37.5,
        "drawFromPosition": 94.4,
        "name": "LeftAux"
      },
      {
        "startPosition": 50,
        "drawToPosition": 50,
        "name": "Equator",
        "drawFull": true,
        "drawFromPosition": 0
      },
      {
        "drawFull": true,
        "drawFromPosition": 50,
        "startPosition": 50,
        "drawToPosition": 100,
        "name": "EquatorBottom"
      },
      {
        "drawFull": false,
        "startPosition": 74,
        "name": "RightBottom",
        "drawDirection": -1,
        "endPosition": 101,
        "drawFromPosition": 50,
        "extend": true,
        "drawToPosition": 100
      },
      {
        "name": "Right1",
        "startPosition": 74,
        "drawToPosition": 50,
        "drawFull": true,
        "endPosition": 101,
        "drawFromPosition": 0
      },
      {
        "name": "PrimaryRight",
        "drawToPosition": 0,
        "drawFromPosition": 100,
        "startPosition": 96.9,
        "endPosition": 101,
        "drawFull": true
      }
    ],
    "mask": [
      {
        "grid": 0,
        "vertical": [
          "Left Border",
          "Equator"
        ],
        "name": "Headline",
        "polyOnly": true,
        "horizontal": [
          "PrimaryTop",
          "LeftTopAux"
        ],
        "asset": 0
      },
      {
        "grid": 0,
        "horizontal": [
          "LeftTopAux",
          "Equator"
        ],
        "polyOnly": true,
        "name": "Description",
        "vertical": [
          "Left Border",
          "Equator"
        ],
        "asset": 0
      }
    ],
    "duration": "1000",
    "id": 1
  },
  {
    "duration": "1000",
    "delayHorizontal": false,
    "delayVertical": false,
    "mask": [
      {
        "asset": 0,
        "horizontal": [
          "PrimaryTop",
          "LeftTopAux"
        ],
        "polyOnly": true,
        "name": "Headline",
        "vertical": [
          "Left Border",
          "Equator"
        ],
        "grid": 0
      },
      {
        "name": "Description",
        "horizontal": [
          "LeftTopAux",
          "Equator"
        ],
        "asset": 0,
        "vertical": [
          "Left Border",
          "Equator"
        ],
        "grid": 0,
        "polyOnly": true
      },
      {
        "assetPositionWithMask": true,
        "container": "mask",
        "asset": 0,
        "name": "Hero",
        "grid": 0,
        "vertical": [
          "Equator",
          "HeroMaskLine"
        ],
        "coverFill": true,
        "horizontal": [
          "PrimaryTop",
          "EquatorRight"
        ]
      },
      {
        "vertical": [
          "Left Border",
          "Grid1MaskLine"
        ],
        "container": "mask",
        "grid": 0,
        "asset": 0,
        "coverFill": true,
        "name": "Grid1",
        "horizontal": [
          "Equator",
          "PrimaryBottom"
        ]
      },
      {
        "container": "mask",
        "name": "Grid2",
        "vertical": [
          "LeftAux",
          "Grid2MaskLine"
        ],
        "grid": 0,
        "coverFill": true,
        "horizontal": [
          "LeftAux",
          "PrimaryBottom"
        ],
        "asset": 0,
        "assetPositionWithMask": true
      }
    ],
    "name": "ChapterEntry",
    "circle": [],
    "vertical": [
      {
        "drawToPosition": 50,
        "drawFull": true,
        "drawFromPosition": 0,
        "endPosition": -1,
        "startPosition": -1,
        "name": "Left1"
      },
      {
        "drawToPosition": 0,
        "drawFull": true,
        "drawFromPosition": 100,
        "name": "PrimaryLeft",
        "endPosition": -1,
        "startPosition": -1
      },
      {
        "drawFromPosition": 50,
        "drawFull": true,
        "drawToPosition": 100,
        "endPosition": 25,
        "startPosition": 25,
        "name": "Left1Bottom"
      },
      {
        "drawFromPosition": 94.4,
        "drawToPosition": 72.2,
        "drawFull": true,
        "name": "LeftAux",
        "endPosition": 37.5,
        "startPosition": 37.5
      },
      {
        "name": "Equator",
        "drawFromPosition": 0,
        "drawFull": true,
        "drawToPosition": 50,
        "endPosition": 50,
        "startPosition": 50
      },
      {
        "drawFromPosition": 50,
        "endPosition": 50,
        "drawToPosition": 100,
        "startPosition": 50,
        "drawFull": true,
        "name": "EquatorBottom"
      },
      {
        "drawFromPosition": 50,
        "drawDirection": -1,
        "endPosition": 101,
        "drawFull": true,
        "startPosition": 101,
        "drawToPosition": 100,
        "extend": true,
        "name": "RightBottom"
      },
      {
        "drawFull": true,
        "drawToPosition": 50,
        "endPosition": 101,
        "startPosition": 101,
        "drawFromPosition": 0,
        "name": "Right1"
      },
      {
        "drawFromPosition": 100,
        "endPosition": 101,
        "drawFull": true,
        "startPosition": 101,
        "drawToPosition": 0,
        "name": "PrimaryRight"
      },
      {
        "endPosition": 25,
        "delay": 250,
        "drawFull": true,
        "drawFromPosition": 0,
        "startAlpha": 0.01,
        "startPosition": 0,
        "name": "Grid1MaskLine",
        "drawToPosition": 100
      },
      {
        "drawFull": true,
        "startPosition": 50,
        "endPosition": 100,
        "startAlpha": 0.01,
        "drawFromPosition": 0,
        "drawToPosition": 100,
        "name": "HeroMaskLine"
      },
      {
        "drawToPosition": 100,
        "startPosition": 37.5,
        "delay": 500,
        "startAlpha": 0.01,
        "drawFromPosition": 0,
        "drawFull": true,
        "name": "Grid2MaskLine",
        "endPosition": 50
      }
    ],
    "id": 2,
    "horizontal": [
      {
        "startPosition": 5.6,
        "endPosition": 5.6,
        "drawFromPosition": 0,
        "drawToPosition": 100,
        "drawFull": true,
        "name": "PrimaryTop"
      },
      {
        "drawFull": true,
        "startPosition": 27.5,
        "drawFromPosition": 0,
        "endPosition": 27.5,
        "delay": 100,
        "name": "LeftTopAux",
        "drawToPosition": 50
      },
      {
        "drawToPosition": 50,
        "name": "Equator",
        "drawFull": true,
        "drawFromPosition": 0,
        "endPosition": 50,
        "drawDirection": 1,
        "startPosition": 50
      },
      {
        "startPosition": 72.2,
        "drawDirection": 1,
        "drawFromPosition": 50,
        "name": "LeftAux",
        "drawToPosition": 25,
        "endPosition": 72.2,
        "drawFull": true
      },
      {
        "startPosition": 72.2,
        "endPosition": 72.2,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "delay": 100,
        "name": "EquatorRight",
        "drawFull": true
      },
      {
        "drawFromPosition": 0,
        "startPosition": 94.4,
        "drawFull": true,
        "endPosition": 94.4,
        "name": "PrimaryBottom",
        "delay": 200,
        "drawToPosition": 100
      }
    ],
    "drawBorder": true
  },
  {
    "mask": [
      {
        "grid": 0,
        "name": "Headline",
        "vertical": [
          "Left Border",
          "Equator"
        ],
        "polyOnly": true,
        "asset": 0,
        "horizontal": [
          "PrimaryTop",
          "LeftTopAux"
        ]
      },
      {
        "name": "Description",
        "horizontal": [
          "LeftTopAux",
          "Equator"
        ],
        "grid": 0,
        "asset": 0,
        "polyOnly": true,
        "vertical": [
          "Left Border",
          "Equator"
        ]
      },
      {
        "grid": 0,
        "name": "Hero",
        "asset": 0,
        "container": "mask",
        "vertical": [
          "Equator",
          "HeroMaskLine"
        ],
        "coverFill": true,
        "horizontal": [
          "PrimaryTop",
          "EquatorRight"
        ],
        "assetPositionWithMask": true
      },
      {
        "container": "mask",
        "vertical": [
          "Left Border",
          "Grid1MaskLine"
        ],
        "asset": 0,
        "coverFill": true,
        "name": "Grid1",
        "grid": 0,
        "horizontal": [
          "Equator",
          "PrimaryBottom"
        ]
      },
      {
        "vertical": [
          "LeftAux",
          "Grid2MaskLine"
        ],
        "coverFill": true,
        "container": "mask",
        "asset": 0,
        "assetPositionWithMask": true,
        "grid": 0,
        "horizontal": [
          "LeftAux",
          "PrimaryBottom"
        ],
        "name": "Grid2"
      }
    ],
    "duration": "1000",
    "name": "ChapterEntry",
    "id": 2,
    "delayHorizontal": false,
    "vertical": [
      {
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "endPosition": -1,
        "name": "Left1",
        "drawFull": true,
        "startPosition": -1
      },
      {
        "drawFromPosition": 100,
        "startPosition": -1,
        "drawFull": true,
        "drawToPosition": 0,
        "endPosition": -1,
        "name": "PrimaryLeft"
      },
      {
        "endPosition": 25,
        "name": "Left1Bottom",
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "startPosition": 25,
        "drawFull": true
      },
      {
        "drawFull": true,
        "startPosition": 37.5,
        "name": "LeftAux",
        "drawToPosition": 72.2,
        "drawFromPosition": 94.4,
        "endPosition": 37.5
      },
      {
        "drawToPosition": 50,
        "name": "Equator",
        "startPosition": 50,
        "drawFromPosition": 0,
        "endPosition": 50,
        "drawFull": true
      },
      {
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "startPosition": 50,
        "name": "EquatorBottom",
        "endPosition": 50,
        "drawFull": true
      },
      {
        "name": "RightBottom",
        "drawDirection": -1,
        "drawFromPosition": 50,
        "startPosition": 101,
        "endPosition": 101,
        "extend": true,
        "drawFull": true,
        "drawToPosition": 100
      },
      {
        "drawFull": true,
        "endPosition": 101,
        "drawToPosition": 50,
        "startPosition": 101,
        "name": "Right1",
        "drawFromPosition": 0
      },
      {
        "endPosition": 101,
        "drawFull": true,
        "drawToPosition": 0,
        "startPosition": 101,
        "drawFromPosition": 100,
        "name": "PrimaryRight"
      },
      {
        "startPosition": 25,
        "name": "Grid1MaskLine",
        "drawToPosition": 100,
        "endPosition": 0,
        "startAlpha": 0.01,
        "drawFromPosition": 0,
        "delay": 1500,
        "drawFull": true
      },
      {
        "drawToPosition": 100,
        "endPosition": 50,
        "startAlpha": 0.01,
        "drawFromPosition": 0,
        "startPosition": 100,
        "delay": 3000,
        "name": "HeroMaskLine",
        "drawFull": true
      },
      {
        "endPosition": 37.5,
        "delay": 2500,
        "startPosition": 50,
        "drawFromPosition": 0,
        "startAlpha": 0.01,
        "name": "Grid2MaskLine",
        "drawFull": true,
        "drawToPosition": 100
      }
    ],
    "delayVertical": false,
    "horizontal": [
      {
        "name": "PrimaryTop",
        "drawToPosition": 100,
        "drawFromPosition": 0,
        "startPosition": 5.6,
        "endPosition": 5.6,
        "drawFull": true
      },
      {
        "delay": 100,
        "startPosition": 27.5,
        "drawFromPosition": 0,
        "name": "LeftTopAux",
        "drawToPosition": 50,
        "drawFull": true,
        "endPosition": 27.5
      },
      {
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "name": "Equator",
        "drawDirection": 1,
        "endPosition": 50,
        "drawFull": true,
        "startPosition": 50
      },
      {
        "name": "LeftAux",
        "drawToPosition": 25,
        "startPosition": 72.2,
        "drawFull": true,
        "endPosition": 72.2,
        "drawDirection": 1,
        "drawFromPosition": 50
      },
      {
        "drawFull": true,
        "drawToPosition": 100,
        "delay": 100,
        "name": "EquatorRight",
        "drawFromPosition": 50,
        "endPosition": 72.2,
        "startPosition": 72.2
      },
      {
        "drawFull": true,
        "delay": 200,
        "startPosition": 94.4,
        "drawToPosition": 100,
        "name": "PrimaryBottom",
        "drawFromPosition": 0,
        "endPosition": 94.4
      }
    ],
    "drawBorder": true,
    "circle": []
  },
  {
    "name": "ChapterExit",
    "vertical": [
      {
        "drawToPosition": 50,
        "drawFull": true,
        "name": "Left1",
        "drawFromPosition": 0,
        "endPosition": 26,
        "startPosition": -1
      },
      {
        "name": "PrimaryLeft",
        "endPosition": 3.1,
        "drawToPosition": 0,
        "drawFull": true,
        "drawFromPosition": 100,
        "startPosition": -1
      },
      {
        "drawFull": true,
        "endPosition": 26,
        "name": "Left1Bottom",
        "drawToPosition": 100,
        "startPosition": 25,
        "drawFromPosition": 50
      },
      {
        "endAlpha": 0,
        "drawToLine": "PrimaryBottom",
        "name": "LeftAux",
        "drawFromLine": "LeftAux",
        "startPosition": 37.5,
        "drawFull": false,
        "extend": true
      },
      {
        "startPosition": 50,
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "drawFull": true,
        "name": "Equator"
      },
      {
        "startPosition": 50,
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "name": "EquatorBottom",
        "drawFull": true
      },
      {
        "startPosition": 101,
        "name": "RightBottom",
        "extend": true,
        "drawFromPosition": 50,
        "drawDirection": 1,
        "drawFull": true,
        "drawToPosition": 100,
        "endPosition": 74
      },
      {
        "endPosition": 74,
        "drawFromPosition": 0,
        "drawFull": true,
        "startPosition": 101,
        "name": "Right1",
        "drawToPosition": 50
      },
      {
        "endPosition": 96.9,
        "drawToPosition": 0,
        "startPosition": 101,
        "name": "PrimaryRight",
        "drawFromPosition": 100,
        "drawFull": true
      }
    ],
    "drawBorder": true,
    "circle": [],
    "id": 3,
    "delayHorizontal": false,
    "delayVertical": false,
    "duration": "1000",
    "mask": [],
    "horizontal": [
      {
        "name": "PrimaryTop",
        "drawFromPosition": 0,
        "startPosition": 5.6,
        "drawToPosition": 100,
        "drawFull": true
      },
      {
        "endPosition": 50,
        "drawToPosition": 50,
        "removeAtEndPosition": true,
        "drawFull": true,
        "startPosition": 27.5,
        "name": "LeftTopAux",
        "drawFromPosition": 0
      },
      {
        "startPosition": 50,
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "name": "Equator",
        "drawDirection": 1,
        "drawFull": true
      },
      {
        "extend": true,
        "endPosition": 94.4,
        "drawFull": false,
        "drawToLine": "Left1Bottom",
        "drawDirection": 1,
        "drawFromPosition": 50,
        "startPosition": 72.2,
        "name": "LeftAux"
      },
      {
        "drawToPosition": 100,
        "drawFull": true,
        "name": "EquatorRight",
        "drawFromPosition": 50,
        "delay": 100,
        "endPosition": 50,
        "startPosition": 72.2
      },
      {
        "drawFromPosition": 0,
        "drawFull": true,
        "startPosition": 94.4,
        "drawToPosition": 100,
        "name": "PrimaryBottom",
        "delay": 200
      }
    ]
  }
]